document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-product-description]').forEach(function (content) {
    var wrapper = content.closest('.product__description');
    if (!wrapper) return;
    var button = wrapper.querySelector('[data-product-description-toggle]');
    if (!button) return;

    requestAnimationFrame(function () {
      if (content.scrollHeight > content.clientHeight + 1) {
        button.hidden = false;
      }
    });

    button.addEventListener('click', function () {
      var expanded = content.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var moreLabel = button.querySelector('[data-label-more]');
      var lessLabel = button.querySelector('[data-label-less]');
      if (moreLabel) moreLabel.hidden = expanded;
      if (lessLabel) lessLabel.hidden = !expanded;
    });
  });
});
